import ApiService from '../../../../../../../services/ApiService'
import Utils from '../../../../../../../Utils/FormatDate'
import TableColumns from '../../../../../../../Utils/TableColumns'
import ServiceOrderRating from '../../../../../ServiceOrders/components/ServiceOrderRating/ManageServiceOrderRating.vue'

export default {
  async created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = this.institution.id

    this.values = [this.institutionId]

    await Promise.all([
      this.getInstitutions(),
      this.getDepartments(),
      this.getUsers(),
      this.getUnidades(),
    ])

    if (this.institution.userType == 6) {
      this.userRequesterId = this.userLogged.id
    }

    if (this.institution.userType === 2 || this.institution.userType === 3) {
      this.calledStatus = ['Enviado']
      this.filter.status = [0]
    }

    this.headers = TableColumns.mergeSavedColumns(
      this.userLogged.bigDataCalledColumns,
      this.headers,
      null,
      'calledNumber'
    )

    await this.loadPreset()

    this.connectSockets()
    this.fetchIntervalFn = setInterval(() => this.updateTable(), 300000)
  },

  beforeDestroy() {
    this.disconnectSockets()
    if (this.fetchIntervalFn) clearInterval(this.fetchIntervalFn)
  },

  data: () => ({
    presetLoading: false,
    hasSavedPreset: false,
    calledSockets: [],
    fetchIntervalFn: null,
    mesRing: null,
    institutionSearch: '',
    values: [],
    totalItensOnPage: 0,
    visible: false,
    institution: {},
    buttonDeleteVisible: false,
    dialog: false,
    editDialog: false,
    deleteDialog: false,
    deleteServiceOrderDialog: false,
    serviceOrderRatingDialog: false,
    dialogKey: false,
    loading: false,
    institutionLoading: false,
    unidadeLoading: false,
    departmentLoading: false,
    usersLoading: false,
    menuStartDate: false,
    menuEndDate: false,
    startDate: null,
    endDate: null,
    calledStartDate: null,
    calledEndDate: null,
    minDate: null,
    calledRatingQuantity: 0,
    expanded: [],
    institutionId: null,
    institutions: [],
    unidadeId: null,
    unidades: [],
    departmentId: null,
    departments: [],
    userLogged: {},
    userRequesterId: null,
    users: [],
    calledSelected: [],
    currentCalled: {},
    calleds: [],
    calledRatings: [],
    page: 1,
    totalPages: 1,
    pageSize: 10,
    sizes: [10, 30, 90, 180],
    totalItems: 0,
    apiService: new ApiService(),
    filter: {
      page: 1,
      institutionIds: [],
      pageSize: 10,
      institutionId: null,
      unidadeId: null,
      standardEquipament: null,
      equipment: null,
      serialNumber: null,
      identification: null,
      departmentId: null,
      status: null,
      startDate: null,
      endDate: null,
      serviceOrderNumber: null,
      propertyCode: null,
      calledNumber: null,
      userRequesterId: null,
      ordination: null,
    },
    standardEquipmentName: null,
    equipmentName: null,
    equipmentSerialNumber: null,
    equipmentIdentification: null,
    serviceOrderNumber: null,
    equipmentPropertyCode: null,
    menuLoading: false,
    headMenu: false,
    calledNumber: null,
    calledStatus: [],
    message: '',
    status: ['Enviado', 'Em Andamento', 'Fechado', 'Reprovado'],
    headers: [
      {
        text: 'Nº Chamado',
        align: 'center',
        value: 'calledNumber',
        active: true,
      },
      {
        text: 'Número de Série',
        align: 'center',
        value: 'equipment.serialNumber',
        active: false,
      },
      {
        text: 'Setor',
        align: 'center',
        value: 'department.name',
        active: false,
      },
      {
        text: 'Instituição',
        align: 'center',
        value: 'institution.name',
        active: false,
      },
      {
        text: 'Unidade',
        align: 'center',
        value: 'unidade.name',
        active: false,
      },
      {
        text: 'Solicitante',
        align: 'center',
        value: 'requester',
        active: true,
      },
      {
        text: 'Equipamento',
        align: 'center',
        value: 'equipment.name',
        active: true,
      },
      {
        text: 'Equip. ID',
        align: 'center',
        value: 'equipment',
        active: true,
      },
      {
        text: 'Urgência',
        align: 'center',
        value: 'urgency',
        active: true,
      },
      {
        text: 'Data Solicitação',
        align: 'center',
        value: 'createdAt',
        active: true,
      },
      {
        text: 'Estado',
        align: 'center',
        value: 'status',
        active: true,
      },
      {
        text: 'Data Estado',
        align: 'center',
        value: 'statusDate',
        active: true,
      },
      // {
      //   text: 'Avaliação',
      //   align: 'center',
      //   value: 'rating',
      //   sortable: false,
      //   active: true,
      // },
    ],

    headersMobileBase: [
      {
        text: 'Nº Chamado',
        align: 'center',
        value: 'calledNumber',
      },
      {
        text: 'Solicitante',
        align: 'center',
        value: 'requester',
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
  }),

  components: {
    ServiceOrderRating,
  },

  methods: {
    connectSockets() {
      this.disconnectSockets()
      const userId = this.userLogged.id
      this.calledSockets = this.values.map((institutionId) => {
        const socket = new WebSocket(
          `${process.env.VUE_APP_BASE_URL_SOCKET}?chatId=institution-${institutionId}`
        )
        const $context = this
        socket.onmessage = async function (e) {
          $context.updateTable()
          try {
            const audioInCalleds = JSON.parse(localStorage.getItem('user')).audioInCalleds
            const msg = JSON.parse(e.data)
            if (audioInCalleds === true && userId !== msg.userRequesterId) {
              $context.playAlertSound()
            }
          } catch (_) {}
        }
        return socket
      })
    },

    disconnectSockets() {
      this.calledSockets.forEach((s) => {
        try { s.close() } catch (_) {}
      })
      this.calledSockets = []
    },

    playAlertSound() {
      const url =
        'https://equipacarefix.blob.core.windows.net/public/universfield-soft-bell-ding-485895.mp3'
      window.AudioContext = window.AudioContext || window.webkitAudioContext
      const context = new AudioContext()
      this.mesRing = context.createBufferSource()
      this.mesRing.connect(context.destination)
      const request = new XMLHttpRequest()
      const $context = this
      request.open('GET', url, true)
      request.responseType = 'arraybuffer'
      request.onload = function () {
        context.decodeAudioData(request.response, function (buffer) {
          $context.mesRing.buffer = buffer
          $context.mesRing.start(0)
          setTimeout(() => {
            if ($context.mesRing) {
              $context.mesRing.stop()
              $context.mesRing = null
            }
          }, 1100)
        })
      }
      request.send()
    },

    getPresetData() {
      return {
        values: this.values,
        unidadeId: this.unidadeId,
        departmentId: this.departmentId,
        standardEquipmentName: this.standardEquipmentName,
        equipmentName: this.equipmentName,
        equipmentSerialNumber: this.equipmentSerialNumber,
        equipmentIdentification: this.equipmentIdentification,
        equipmentPropertyCode: this.equipmentPropertyCode,
        calledNumber: this.calledNumber,
        serviceOrderNumber: this.serviceOrderNumber,
        userRequesterId: this.userRequesterId,
        calledStatus: this.calledStatus,
        calledStartDate: this.calledStartDate,
        calledEndDate: this.calledEndDate,
        startDate: this.startDate,
        endDate: this.endDate,
      }
    },

    applyPreset(data) {
      if (data.values !== undefined) this.values = data.values
      if (data.unidadeId !== undefined) this.unidadeId = data.unidadeId
      if (data.departmentId !== undefined) this.departmentId = data.departmentId
      if (data.standardEquipmentName !== undefined) this.standardEquipmentName = data.standardEquipmentName
      if (data.equipmentName !== undefined) this.equipmentName = data.equipmentName
      if (data.equipmentSerialNumber !== undefined) this.equipmentSerialNumber = data.equipmentSerialNumber
      if (data.equipmentIdentification !== undefined) this.equipmentIdentification = data.equipmentIdentification
      if (data.equipmentPropertyCode !== undefined) this.equipmentPropertyCode = data.equipmentPropertyCode
      if (data.calledNumber !== undefined) this.calledNumber = data.calledNumber
      if (data.serviceOrderNumber !== undefined) this.serviceOrderNumber = data.serviceOrderNumber
      if (data.userRequesterId !== undefined) this.userRequesterId = data.userRequesterId
      if (data.calledStatus !== undefined) this.calledStatus = data.calledStatus
      if (data.calledStartDate !== undefined) this.calledStartDate = data.calledStartDate
      if (data.calledEndDate !== undefined) this.calledEndDate = data.calledEndDate
      if (data.startDate !== undefined) this.startDate = data.startDate
      if (data.endDate !== undefined) this.endDate = data.endDate
    },

    async loadPreset() {
      if (!this.userLogged.id) return
      try {
        const response = await this.apiService.get(
          `bigDataFilterPreset/${this.userLogged.id}/2`,
          null,
          false,
          false
        )
        if (response && response.content) {
          this.applyPreset(JSON.parse(response.content.filterJson))
          this.hasSavedPreset = true
          this.filterTable()
        }
      } catch (_) {}
    },

    async savePreset() {
      this.presetLoading = true
      try {
        await this.apiService.post('bigDataFilterPreset', {
          userId: this.userLogged.id,
          tab: 2,
          filterJson: JSON.stringify(this.getPresetData()),
        })
        this.hasSavedPreset = true
        this.$toast.success('Filtro salvo com sucesso!')
      } catch (_) {
        this.$toast.error('Erro ao salvar filtro')
      }
      this.presetLoading = false
    },

    async removePreset() {
      this.presetLoading = true
      try {
        await this.apiService.delete(
          `bigDataFilterPreset/${this.userLogged.id}/2`,
          null,
          false,
          false
        )
        this.hasSavedPreset = false
        this.$toast.success('Filtro salvo removido!')
      } catch (_) {
        this.$toast.error('Erro ao remover filtro')
      }
      this.presetLoading = false
    },

    removeCalledStatus(item) {
      this.calledStatus.splice(this.calledStatus.indexOf(item), 1)
      this.calledStatus = [...this.calledStatus]
    },

    updateHeaders() {
      this.menuLoading = true

      // Garante que "Nº Chamado" permaneça como primeira coluna ao salvar.
      const calledNumberIndex = this.headers.findIndex(
        (x) => x.value === 'calledNumber'
      )
      if (calledNumberIndex > 0) {
        const [calledNumberHeader] = this.headers.splice(calledNumberIndex, 1)
        this.headers.unshift(calledNumberHeader)
      }

      const json = JSON.stringify(this.headers)
      this.apiService
        .post('user/saveColumns/big-data-called', { columns: json })
        .then(() => {
          this.userLogged.bigDataCalledColumns = json

          localStorage.removeItem('user')
          localStorage.setItem('user', JSON.stringify(this.userLogged))
          this.$toast.success('Configuração salva no seu usuário!')

          this.headMenu = false
          this.menuLoading = false
        })
        .catch(() => {
          this.menuLoading = false
        })
    },
    addCalled() {
      this.$router.push('/newCalled')
    },

    editCalled(called) {
      this.currentCalled = called
      window
        .open(
          `/bigData-editCalled/${this.currentCalled.id}/${this.currentCalled.institutionId}`,
          '_blank'
        )
        .focus()
    },

    deleteCalled(called) {
      this.currentCalled = called
      this.dialogKey = !this.dialogKey
      this.deleteDialog = true
    },

    callFormRating(called) {
      this.currentCalled = called
      this.dialogKey = !this.dialogKey
      this.serviceOrderRatingDialog = true
    },

    closeDialog() {
      this.dialog = false
      this.editDialog = false
      this.serviceOrderRatingDialog = false
      this.$router.go()
      this.updateTable()
    },

    isInactive(value) {
      let result = ''
      if (value.equipment) {
        value.equipment.department.status == 1 ? 'departmentInactive' : ''
      }
      return result
    },

    filterTable() {
      this.page = 1
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize
      this.filter.institutionIds = this.values
      this.filter.standardEquipment = this.standardEquipmentName
      this.filter.equipment = this.equipmentName
      this.filter.serialNumber = this.equipmentSerialNumber
      this.filter.identification = this.equipmentIdentification
      this.filter.departmentId = this.departmentId
      this.filter.status =
        this.calledStatus != null
          ? this.status.indexOf(this.calledStatus)
          : null
      this.filter.status = this.calledStatus.map((x) => this.status.indexOf(x))
      this.filter.startDate = this.calledStartDate
      this.filter.endDate = this.calledEndDate
      this.filter.serviceOrderNumber = this.serviceOrderNumber
      this.filter.propertyCode = this.equipmentPropertyCode
      this.filter.calledNumber = this.calledNumber

      this.updateTable()
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },

    getUrgencyClass(urgency) {
      switch (urgency) {
        case 0:
          return 'high'
        case 1:
          return 'median'
        case 2:
          return 'low'
        default:
          return ''
      }
    },

    getUrgency(urgency) {
      switch (urgency) {
        case 0:
          return 'Alta'
        case 1:
          return 'Média'
        case 2:
          return 'Baixa'
        default:
          return ''
      }
    },

    getStatusClass(status) {
      switch (status) {
        case 0:
          return 'sent'
        case 1:
          return 'inProgress'
        case 2:
          return 'closed'
        default:
          return ''
      }
    },

    getStatus(status) {
      switch (status) {
        case 1:
          return 'Em Andamento'
        case 2:
          return 'Fechado'
        case 3:
          return 'Reprovado'
        default:
          return 'Enviado'
      }
    },

    getLastStep(item) {
      if (item.serviceOrder) {
        if (item.serviceOrder.status == 1) {
          return null
        }
        const services = item.serviceOrder.services

        if (services) {
          const lastStep = services[services.length - 1]

          if (lastStep) {
            switch (lastStep.statusStepServiceOrder) {
              case 0:
                return 'Manutenção terceirizada in loco'
              case 1:
                return 'Manutenção terceirizada externa'
              case 2:
                return 'Manutenção interna'
              case 3:
                return 'Aguardando peça'
              case 4:
                return 'Aguardando orçamento'
              case 5:
                return 'Aguardando avaliação externa'
              case 6:
                return 'Aguardando aprovação de orçamento'
              case 7:
                return 'Aguardando liberação do setor'
              default:
                return null
            }
          }
        }
      }
    },

    getStatusDate(item) {
      if (item.serviceOrder) {
        if (item.serviceOrder.services.length > 0) {
          const lastStep =
            item.serviceOrder.services[item.serviceOrder.services.length - 1]
          return this.formatDate(lastStep.dateTimeStartStep)
        }
        if (item.serviceOrder.status == 1) {
          return this.formatDate(item.serviceOrder.closeServiceOrderDateTime)
        }
        return this.formatDate(item.serviceOrder.createAt)
      } else if (item.calledStatus == 3) {
        return this.formatDate(item.disaprovedDate)
      } else if (item.calledStatus == 2) {
        return this.formatDate(item.updatedAt)
      } else {
        return this.formatDate(item.createdAt)
      }
    },

    deleteManyCalled() {
      this.calledSelected.map((called) => {
        if (called.serviceOrderId != null) {
          this.deleteServiceOrderDialog = true
          this.deleteDialog = false
        } else {
          this.removeCalled()
        }
      })
    },

    getRating(called) {
      const calledRating = this.calledRatings.find(
        (x) => x.calledId == called.id
      )

      if (calledRating) {
        return calledRating.rating
      }
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService
        .get('institution/listuser')
        .then((response) => {
          this.institutions = response.content
          this.institutionLoading = false
        })
        .catch(() => {
          this.institutionLoading = false
        })
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .post(`bigdata/unidade`, this.values)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
        .catch(() => {
          this.unidadeLoading = false
        })
    },

    async getUsers() {
      this.userLoading = true

      await this.apiService
        .get(`user/list/${this.institutionId}`)
        .then((response) => {
          this.users = response.content
          this.userLoading = false
        })
    },

    async getDepartments() {
      this.departmentLoading = true

      await this.apiService
        .post(`bigdata/department`, this.values)
        .then((response) => {
          this.departments = response.content
          this.departmentLoading = false
        })
        .catch(() => {
          this.departmentLoading = false
        })
    },

    async updateTable() {
      this.loading = true
      this.filter.institutionId = this.institutionId
      this.filter.unidadeId = this.unidadeId
      this.filter.requesterUserId = this.userRequesterId

      await this.apiService
        .post('bigdata/called', this.filter, false, false, false)
        .then((response) => {
          this.totalPages = response.content.pager.totalPages
          this.calleds = response.content.calleds
          this.totalItems = response.content.pager.totalItems
          this.totalItensOnPage = response.content.calleds.length
          this.loading = false
        })
    },

    async removeCalled() {
      this.loading = true

      await this.apiService
        .delete('called/deleteCalled', this.calledSelected)
        .then(() => {
          this.updateTable()
        })
        .catch((err) => {
          this.message = err.message
        })
      this.calledSelected = []
      this.deleteDialog = false
      this.deleteServiceOrderDialog = false
      this.loading = false
    },

    async removeCalledAndOs() {
      this.loading = true

      await this.apiService
        .delete('called/deleteCalledServiceOrder', this.calledSelected)
        .then(() => {
          this.updateTable()
        })
        .catch((err) => {
          this.message = err.message
        })

      this.calledSelected = []
      this.deleteDialog = false
      this.deleteServiceOrderDialog = false
      this.loading = false
    },

    removeInstitution(item) {
      this.values.splice(this.values.indexOf(item), 1)
      this.values = [...this.values]
    },

    reset() {
      this.filter = {
        page: 1,
        pageSize: this.pageSize,
        institutionId: null,
        unidadeId: null,
        institutionIds: [],
        standardEquipament: null,
        equipment: null,
        serialNumber: null,
        identification: null,
        departmentId: null,
        status: null,
        startDate: null,
        endDate: null,
        serviceOrderNumber: null,
        propertyCode: null,
        calledNumber: null,
        userRequesterId: null,
      }
      this.values = []
      this.institutionId =
        this.userLogged.mainType == 0 ? null : this.userLogged.institutionId
      this.unidadeId =
        this.institution.userType == 5 || this.institution.userType == 6
          ? this.userLogged.unidadeId
          : null
      this.departmentId = null
      this.userRequesterId =
        this.institution.userType == 6 ? this.userLogged.id : null
      this.standardEquipmentName = null
      this.equipmentName = null
      this.equipmentSerialNumber = null
      this.equipmentIdentification = null
      this.serviceOrderNumber = null
      this.equipmentPropertyCode = null
      this.calledNumber = null
      this.calledStatus = null
      this.startDate = null
      this.endDate = null

      this.updateTable()
    },

    toggle() {
      this.$nextTick(() => {
        if (this.selectAllInstitutions) {
          this.values = []
        } else {
          this.values = this.institutions.map((x) => x.id)
        }
      })
    },

    formatDate(date) {
      if (date) {
        return Utils.dateTime(date)
      }
      return this.$t('Sem registros')
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    save(date) {
      this.startDate = this.formatInputDate(this.calledStartDate)
      this.$refs.menuStartDate.save(date)
      this.minDate = new Date(this.calledStartDate).toISOString().substr(0, 10)
      this.endDate = this.formatInputDate(this.calledEndDate)
      this.$refs.menuEndDate.save(date)
    },
  },

  computed: {
    // Coluna que recebe o ícone de customizar colunas: a última ativa da
    // tabela, para o ícone não depender de nenhuma coluna específica.
    lastActiveHeaderValue() {
      const active = this.headers.filter((x) => x.active)
      return active.length > 0 ? active[active.length - 1].value : null
    },

    headersMobile() {
      const visible = this.headersMobileBase.filter((mobileHeader) => {
        const header = this.headers.find((x) => x.value === mobileHeader.value)
        return header ? header.active : true
      })
      return visible.length > 0 ? visible : [this.headersMobileBase[0]]
    },

    selectAllInstitutions() {
      return this.values.length === this.institutions.length
    },

    selectSomeInstitutions() {
      return this.values.length > 0 && !this.selectAllInstitutions
    },

    icon() {
      if (this.selectAllInstitutions) return 'mdi-close-box'
      if (this.selectSomeInstitutions) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },

  watch: {
    pageSize() {
      this.filter.pageSize = this.pageSize
      this.filter.page = this.page
      this.updateTable()
    },

    page() {
      this.filter.page = this.page
      this.updateTable()
    },

    calledSelected() {
      this.buttonDeleteVisible = this.calledSelected.length > 0
    },

    values(nv) {
      if (nv) {
        Promise.all([this.getUnidades(), this.getDepartments()])
        this.connectSockets()
      }
    },
  },
}
